import { useEffect, useRef, useState } from 'react';
import './BeforeAfter.css';

function BeforeAfter({ beforeImage, afterImage, beforeAlt = "Before", afterAlt = "After" }) {
  const containerRef = useRef(null);
  const isDraggingRef = useRef(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const container = containerRef.current;
    const beforeImage = container.querySelector(".slider-left");
    const handle = container.querySelector(".slider-handle");
    const sliderButton = container.querySelector(".slider-button");

    // Set initial position to 50%
    const setPosition = (percentage) => {
      handle.style.left = `${percentage}%`;
      sliderButton.style.left = `${percentage}%`;
      beforeImage.style.clipPath = `inset(0 ${100 - percentage}% 0 0)`;
    };
    setPosition(50);

    const handleMove = (clientX) => {
      if (!isDraggingRef.current) return;
      
      const rect = container.getBoundingClientRect();
      const x = clientX - rect.left;
      const percentage = Math.min(Math.max((x / rect.width) * 100, 0), 100);
      
      requestAnimationFrame(() => setPosition(percentage));
    };

    const handleStart = (clientX) => {
      isDraggingRef.current = true;
      handleMove(clientX);
    };

    const handleEnd = () => {
      isDraggingRef.current = false;
    };

    // Update isMobile state on window resize
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);

    // Mouse events
    container.addEventListener('mousedown', (e) => handleStart(e.clientX));
    window.addEventListener('mousemove', (e) => handleMove(e.clientX));
    window.addEventListener('mouseup', handleEnd);

    // Touch events
    container.addEventListener('touchstart', (e) => handleStart(e.touches[0].clientX));
    window.addEventListener('touchmove', (e) => handleMove(e.touches[0].clientX));
    window.addEventListener('touchend', handleEnd);

    return () => {
      // Cleanup
      container.removeEventListener('mousedown', (e) => handleStart(e.clientX));
      window.removeEventListener('mousemove', (e) => handleMove(e.clientX));
      window.removeEventListener('mouseup', handleEnd);
      container.removeEventListener('touchstart', (e) => handleStart(e.touches[0].clientX));
      window.removeEventListener('touchmove', (e) => handleMove(e.touches[0].clientX));
      window.removeEventListener('touchend', handleEnd);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className="custom-image-slider" ref={containerRef}>
      <img className="slider-right" src={isMobile ? afterImage.mobile : afterImage.desktop} alt={afterAlt} />
      <img className="slider-left" src={isMobile ? beforeImage.mobile : beforeImage.desktop} alt={beforeAlt} />
      <div className="slider-button">
        <div className="slider-arrow left-arrow"></div>
        <div className="slider-arrow right-arrow"></div>
      </div>
      <div className="slider-handle"></div>
    </div>
  );
}

export default BeforeAfter;